<template>
  <div>
    <div class="px-4 pt-8 scrollable-content">
      <div class="flex flex-col items-center">
        <img
          src="@/assets/student-icon.svg"
          alt="Student Icon"
          class="w-12 h-12 rounded-full mb-2"
        />
        <p class="text-xs text-gray-400">
          {{ grade }}{{ prefecture ? ` / ${prefecture}` : "" }}
        </p>
        <p class="font-medium">{{ name }}</p>
        <p class="text-xs text-gray-400">{{ studentId }}</p>
      </div>
      <div class="">
        <p class="mb-2 font-medium">- サポート -</p>
        <div class="flex flex-col rounded-md bg-white">
          <m-s-info-item
            text="おといあわせ"
            icon="info"
            path="https://questant.jp/q/popy-online-ask"
          />
          <div class="w-full bg-primary-100" style="height: 1px" />
          <m-s-info-item
            text="公式（こうしき）ガイド"
            icon="info"
            path="https://news.popy.jp/online-study/guide.html"
          />
        </div>
        <div class="mt-4">
          <p class="mb-2 font-medium">- よくあるご質問 -</p>
          <div class="flex flex-col rounded-md bg-white p-4 text-sm">
            <dl class="my-2">
              <dt class="font-bold">毎日必ず参加しないといけないの？</dt>
              <dd>
                参加できない日があっても問題ありません。お子さまと相談して、可能な限りご参加ください。
              </dd>
            </dl>
            <dl class="my-2">
              <dt class="font-bold">自習室に入る前に気をつけることは？</dt>
              <dd>
                iPhoneは「Safari」、それ以外は「Chrome」で、OS、ブラウザを最新バージョンにしてご利用ください。また他アプリを閉じた上でご入室ください。
              </dd>
            </dl>
            <dl class="my-2">
              <dt class="font-bold">
                自習室内で自分や他の人の画面がうつらない。
              </dt>
              <dd>
                ページを更新してください。ただ、ページを更新すると学習ログが分割されるため、不必要な更新はお控えください。
              </dd>
            </dl>
          </div>
          <div class="mt-2 text-gray-500 text-xs">
            ※ その他のご質問は<a
              href="https://news.popy.jp/online-study/5.html"
              target="_blank"
              rel="noopener noreferrer"
              class="text-primary-500"
              >こちら</a
            >
          </div>
        </div>
      </div>
      <div
        class="py-3 mt-8 mb-6 flex justify-center rounded-md border-2 border-red-500 bg-white cursor-pointer transition-all duration-300 hover:bg-gray-100"
        @click="signOut"
      >
        <p class="text-red-500">ログアウト</p>
      </div>
    </div>
    <nav class="fixed-controller">
      <MBottomNav current="setting" />
    </nav>
  </div>
</template>

<script lang="ts">
import { signOut } from "@/api/auth";
import MSInfoItem from "@/components/setting/MSInfoItem.vue";
import MBottomNav from "@/components/MBottomNav.vue";
import store from "@/store";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MSInfoItem,
    MBottomNav
  }
})
export default class Setting extends Vue {
  get name(): string {
    return store.state.student?.data.name ?? "-";
  }

  get studentId(): string {
    return store.state.role?.data.loginId ?? "";
  }

  get grade(): string {
    return store.state.student?.data.grade ?? "";
  }

  get prefecture(): string {
    return store.state.student?.data.prefecture ?? "";
  }

  async signOut() {
    store.commit("SET_LOADING", true);
    store.commit("SET_LOAD_TEXT", "ログアウト中...");
    try {
      await signOut();
      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");
    } catch (e) {
      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");
      alert(
        "ログアウトに失敗しました。時間を置いてから再度実行してみてください"
      );
      return;
    }
    store.commit("SIGN_OUT");
    this.$router.replace("/login");
  }
}
</script>
